class AsyncTaskQueue {
  private queue: (() => Promise<any>)[] = [];
  private running = false;

  public addTask(task: () => Promise<any>) {
    this.queue.push(task);
    if (!this.running) {
      this.running = true;
      this.start();
    }
  }

  public addTasks(tasks: (() => Promise<any>)[]) {
    this.queue.push(...tasks);
    if (!this.running) {
      this.running = true;
      this.startBatch();
    }
  }

  private async worker() {
    while (this.queue.length > 0) {
      const task = this.queue.shift();
      if (task) {
        await task();
      }
    }
  }

  private async workerOne() {
    const task = this.queue.shift();
    if (task) {
      await task();
    }
    this.running = false;
    if (this.queue.length) {
      this.startBatch();
    }
  }

  private async start() {
    // 使用 setTimeout 确保任务队列的执行不会阻碍后续代码的执行
    setTimeout(async () => {
      await this.worker();
      this.running = false;
    }, 0);
  }

  private async startBatch() {
    // 使用 setTimeout 确保任务队列的执行不会阻碍后续代码的执行
    setTimeout(async () => {
      await this.workerOne();
      this.running = false;
    }, 0);
  }
}

// 示例任务
const exampleTask = (name: string, delay: number) => async () => {
  console.log(`Task ${name} started`);
  await new Promise((resolve) => setTimeout(resolve, delay));
  console.log(`Task ${name} completed`);
};

const main = async () => {
  const taskQueue = new AsyncTaskQueue();

  // 添加单个任务到队列
  taskQueue.addTask(exampleTask("A", 2000));

  // 批量添加任务到队列
  taskQueue.addTasks([exampleTask("B", 1000), exampleTask("C", 3000), exampleTask("D", 1500)]);
};

export default AsyncTaskQueue;
